import React, { useState } from 'react';

const WhatsAppContext = React.createContext({
  texto: ''
});
const { Provider, Consumer } = WhatsAppContext;

const WhatsAppProvider = ({ children }) => {
  const [texto, setTexto] = useState('');

  const actualizarTexto = (textoParam) => {
    setTexto(textoParam);
  };

  return (
    <Provider
      value={{
        texto,
        actualizarTexto
      }}
    >
      {children}
    </Provider>
  );
};

export default WhatsAppContext;
export { WhatsAppProvider, Consumer as WhatsAppConsumer };
